import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import routes from '../../routers'
import { ArrowBack } from '../../components/SvgIcon'
import Layout from '../../components/Layout'
import LayoutAccount from '../../components/LayoutAccount'
import { STEPS_ORDER_BOOK } from '../../utils/constants'
import Stepper from './components/Stepper'
import FirstStep from './components/FirstStep'
import SecondStep from './components/SecondStep'
import ThirdStep from './components/ThirdStep'
import PreviewBook from './components/PreviewBook'
import CheckoutStep from './components/CheckoutStep'

import './styles.css'

const FormComponents = {
  [STEPS_ORDER_BOOK['FIRST_STEP']]: FirstStep,
  [STEPS_ORDER_BOOK['SECOND_STEP']]: SecondStep,
  [STEPS_ORDER_BOOK['THIRD_STEP']]: ThirdStep,
  [STEPS_ORDER_BOOK['PREVIEW_STEP']]: PreviewBook,
  [STEPS_ORDER_BOOK['CHECKOUT_STEP']]: CheckoutStep,
}

// Printed cookbook beta: the steps live in the page's history state
// ({ currentStep, groupId, orderId }), so back/forward and reload keep your place.
const CookbookBuilder = () => {
  const { state } = useLocation()
  const currentStep = state?.currentStep || STEPS_ORDER_BOOK['FIRST_STEP']
  const CurrentStep = FormComponents[currentStep]

  return (
    <Layout title="Make a Cookbook">
      <div className="cbPage">
        <div className={`cbIntro ${currentStep > 1 ? 'cbIntroCompact' : ''}`}>
          <div>
            <h1 className="cbTitle">Make a printed cookbook</h1>
            <p className="cbSubtitle">
              Turn your family’s recipes into a real book. Pick the recipes, add a cover and a
              dedication, flip through every page, and we’ll print it and ship it to you.
            </p>
          </div>
          <Link className="cbIntroLink" to={routes.cookbookOrders}>
            Your orders
          </Link>
        </div>
        <Stepper currentStep={currentStep} orderUrlData={state || {}} />
        <CurrentStep key={currentStep} orderUrlData={state || {}} currentStep={currentStep} />
      </div>
    </Layout>
  )
}

const PurchaseBook = () => {
  // Beta users, or everyone once the server opens the cookbook to all
  const isBeta = useSelector(
    (state) => !!(state.user?.data?.cookbook_enabled || state.user?.data?.settings?.cookbook_beta)
  )

  if (isBeta) {
    return <CookbookBuilder />
  }

  return (
    <Layout title="Purchase a Recipe Book">
      <LayoutAccount>
        <h1 className="titleNotification titleChangePassword">Purchase a Recipe Book</h1>
        <div style={{ maxWidth: 533 }} className="innerTextPage">
          Would you like to purchase a beautiful recipe book of all your group’s recipes? <br />
          <br />
          Email <span>info@getmorsel.com</span> and we can help make that happen!
          <Link className="backLink manageTextBack" to={routes.settings}>
            <ArrowBack />
            back
          </Link>
        </div>
      </LayoutAccount>
    </Layout>
  )
}

export default PurchaseBook
